// Helfer für den block-basierten E-Mail-Editor.

let _seq = 0;
const uid = () => `blk_${Date.now().toString(36)}_${(_seq++).toString(36)}`;

export const PLACEHOLDERS = [
  { token: "{{Anrede}}", label: "Anrede" },
  { token: "{{Vorname}}", label: "Vorname" },
  { token: "{{Nachname}}", label: "Nachname" },
  { token: "{{Firma}}", label: "Firma" },
];

export const BLOCK_LABELS = {
  text: "Text",
  heading: "Überschrift",
  image: "Bild",
  button: "Button",
  divider: "Trenner",
  spacer: "Abstand",
};

export function createBlock(type) {
  const base = { id: uid(), type, align: "left" };
  switch (type) {
    case "heading":
      return { ...base, content: "Ihre Überschrift" };
    case "text":
      return { ...base, content: "" };
    case "image":
      return { ...base, src: "", alt: "", width: 528, href: "", align: "center" };
    case "button":
      return { ...base, label: "Mehr erfahren", url: "https://", color: "orange", align: "center" };
    case "spacer":
      return { ...base, height: 20 };
    case "divider":
    default:
      return base;
  }
}

// Reiner Text aus Blöcken (Fallback für Vorschau/Suche/`body`).
export function blocksToPlainText(blocks) {
  if (!Array.isArray(blocks)) return "";
  return blocks
    .map((b) => {
      if (b.type === "text" || b.type === "heading") return b.content || "";
      if (b.type === "button") return `${b.label || ""} (${b.url || ""})`;
      return "";
    })
    .filter(Boolean)
    .join("\n\n");
}

// Wandelt einen reinen Text (Legacy-Vorlage) in einen Text-Block um.
export function textToBlocks(text) {
  if (!text || !text.trim()) return [createBlock("text")];
  return [{ id: uid(), type: "text", align: "left", content: text }];
}

const KNOWN_PLACEHOLDERS = ["anrede", "vorname", "nachname", "firma", "email", "name"];

// Sammelt alle Ziel-URLs (Buttons + Bild-Links) aus den Blöcken.
export function collectUrls(blocks) {
  if (!Array.isArray(blocks)) return [];
  const urls = [];
  blocks.forEach((b) => {
    if (b.type === "button" && b.url) urls.push({ url: b.url, from: "Button" });
    if (b.type === "image" && b.href) urls.push({ url: b.href, from: "Bild-Link" });
  });
  return urls;
}

// Findet unbekannte Platzhalter in Betreff + Textblöcken.
export function findUnknownPlaceholders(blocks, subject = "") {
  const texts = [subject];
  (Array.isArray(blocks) ? blocks : []).forEach((b) => {
    if (b.type === "text" || b.type === "heading") texts.push(b.content || "");
    if (b.type === "button") texts.push(b.label || "");
  });
  const unknown = new Set();
  const re = /\{\{\s*([A-Za-zÄÖÜäöüß]+)\s*\}\}/g;
  texts.forEach((t) => {
    let m;
    while ((m = re.exec(t || "")) !== null) {
      if (!KNOWN_PLACEHOLDERS.includes(m[1].toLowerCase())) unknown.add(m[1]);
    }
  });
  return Array.from(unknown);
}
